import React from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, TextField, Box, Grid } from '@mui/material/';
import { get } from 'lodash';

import loginBackground from '../../assets/img/aplicontroll.png';
import { Container, Title } from '../../styles/GlobalStyles';
import * as actions from '../../store/modules/auth/actions';
import HandleEnterKey from '../../components/HandleEnterKey';

export default function Login(props) {
  const dispatch = useDispatch();
  const prevPath = get(props, 'location.state.prevPath', '/');
  const history = props;

  // const isLoading = useSelector((state) => state.auth.isLoading);

  const [nome, setNome] = React.useState('');
  const [password, setPassword] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    let formErrors = false;

    if (nome.length < 5 || nome.length > 15) {
      formErrors = true;
      toast.error('Nome inválido');
    }

    if (password.length < 6 || password.length > 50) {
      formErrors = true;
      toast.error('Senha inválida');
    }

    if (formErrors) return;

    dispatch(actions.loginRequest({ nome, password, prevPath, history }));
    // window.location.reload();
  };

  return (
    <Container>
      <Box
        style={{
          display: 'flex', // Torna o Box um contêiner flexível
          justifyContent: 'center', // Centraliza os itens no eixo horizontal
          width: '100%', // Opcional, dependendo do layout desejado
        }}
      >
        <img
          src={loginBackground}
          alt="Login Background"
          style={{ width: '40%', marginBottom: '20px' }}
        />
      </Box>

      <Title>Login</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <HandleEnterKey>
          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={12}>
              <TextField
                required
                label="Usuário"
                size="small"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="password"
                required
                label="Senha"
                size="small"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                onClick={handleSubmit}
              >
                Acessar
              </Button>
            </Grid>
          </Grid>
        </HandleEnterKey>
      </Box>
    </Container>
  );
}
